export default __webpack_public_path__ + "static/hw_ff_neopixel-7c5113dd43dd8a8f72c0a7ba0627649a.png";